import React from "react";
import {Link} from "react-router-dom";
import { useTranslation } from 'react-i18next';


// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
// import Weekend from "@material-ui/icons/Weekend";
import Home from "@material-ui/icons/Home";
import Business from "@material-ui/icons/Business";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";

import styles from "assets/jss/material-dashboard-pro-react/views/pricingPageStyle.js";

const useStyles = makeStyles(styles);

export default function HomePage() {
  const { t } = useTranslation(); 

  const classes = useStyles();

  const [hero] = React.useState(require("assets/img/hero.png"));
  const [noteDetail] = React.useState(require("assets/img/note-detail.png"));
  const [mobile] = React.useState(require("assets/img/mobile.png"));
  const [googlePlay] = React.useState(require("assets/img/google-play.png"));
  const [appleStore] = React.useState(require("assets/img/apple-store.png"));
  const [logo] = React.useState(require("assets/img/logotipo-white.png"));
  const [logofernanda] = React.useState(require("assets/img/fernanda_eucene_logotipo_rosa.png"));
  const [logosissara] = React.useState(require("assets/img/logosissara.png"));
  
  return (
    <div className='landingPage'>

      <section className="hero-page">
              <div className="container-fluid h-100">
                  <div className="row justify-content-md-center align-items-center h-100">
                      <div className="col-12 col-sm-12 col-md-5">
                          <h1>
                          {t('home.organize_your_business_with')} <b>{t('label.beakt_day')} </b>{t('home.and_have')}
                          </h1>
                          <p></p>
                      </div>
                      <div className="col-12 col-sm-12 col-md-5">
                          <img src={hero} alt="" className="img-fluid"/>
                      </div>
                  </div>
              </div>
          </section>

          <div className="container">
              <div className="row justify-content-md-center">
                  <div className="col-12 col-md-10">
                      <div className="trial-card">
                      	{t('home.want_to_experiment')}
                          <input type="email" className="form-control mt-3" placeholder={t('home.enter_your_email')} />
                      </div>
                  </div>
              </div>
          </div>
                    
          <section>
              <div className="quem-usa">
                  <div className="container">
                      <div className="row">
                          <div className="col-12">
                              <div className="title">
                                {t('home.who_already_uses')}
                              </div>
                          </div>
                          <div className="col-4">
                              <img width="300px" src="https://app2.pagolivre.com.br/assets/themes/emagrecentro/images/emagrecentro.png" alt=""   className="img-fluid"/>
                          </div>
                          <div className="col-4">
                              <img width="200px" src={logofernanda} alt=""   className="img-fluid"/>
                         </div>
                          <div className="col-4">
                              <img width="350px" src={logosissara} alt=""   className="img-fluid"/>
                         </div>
                      </div>
                  </div>
              </div>
          </section>
        
          <section>
              <div className="container mt-5 mb-5">
                  <div className="row align-items-center">
                      <div className="col-12 col-sm-6 col-md-6">
                          <h3>
                            	{t('home.change_the_way')}
                          </h3>
                          <p>
                            {t('home.with_beakt_day')}
                            </p>
                            <p>
                            {t('home.designed_to_serve')+"!"}
                            </p>
                      </div>
                      <div className="col-12 col-sm-6 col-md-6 text-center">
                          <img src={noteDetail} alt=""   className="img-fluid"/>
                      </div>
                  </div>
              </div>
          </section>

          <section>
              <div className="contador">
                  <div className="container">
                      <div className="row">
                          <div className="col-12 title text-center">
                              {t('home.total_are')}
                          </div>
                          <div className="col-12 col-sm-4 col-md-4 text-center">
                              <h2 className="timer count-title count-number" data-to="300" data-speed="1500">2000</h2>
                              <p className="mb-0">{t('home.schedules_carried_out')} </p>
                          </div>
                          <div className="col-12 col-sm-4 col-md-4 text-center">
                              <h2 className="timer count-title count-number" data-to="1700" data-speed="1500">150</h2>
                              <p className="mb-0">{t('home.registered_companies')} </p>
                          </div>
                          <div className="col-12 col-sm-4 col-md-4 text-center">
                              <h2 className="timer count-title count-number" data-to="11900" data-speed="1500">900</h2>
                              <p className="mb-0">{t('home.network_clients')} </p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

          <section>
              <div className="container mt-5 mb-5">
                  <div className="row align-items-center">
                      <div className="col-12 col-sm-12 col-md-12 text-center">
                          <h3 className="title">
                          	{t('home.see_beakt_in_action')}
                          </h3>
                          <button type="button" className='btn btn-primary mb-3'>{t('home.create_an_account')} </button>
                          <br/>
                          <img src={noteDetail} alt=""   className="img-fluid"/>
                          <a id="play-video" className="video-play-button" href="javascript:void(0)">
                              <span></span>
                          </a>
                          <div id="video-overlay" className="video-overlay">
                              <a href="#" className="video-overlay-close">&times;</a>
                          </div>                          
                      </div>
                  </div>
              </div>
          </section>

            
          <section>
            <div className="price-section">
            <div className={classes.container}>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={6}>
                <h2 className={classes.title}>{t('home.select_the_best_plan')} </h2>
                <h5 className={classes.description}>
                    {t('home.and_change')}
                </h5>
                </GridItem>
            </GridContainer>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={3}>
                <Card pricing plain>
                    <CardBody pricing plain>
                    <h6 className={classes.cardCategory}>{t('home.ligth')} </h6>
                    <div className={classes.icon}>
                        <Icon className={classes.iconWhite}>weekend</Icon>
                    </div>
                    <h3
                        className={`${classes.cardTitleWhite} ${classes.marginTop30}`}
                    >
                        {t('sale.dollar_sign')} 19,99
                    </h3>
                    <p className={classes.cardCategory}>
                        <b>{t('home.01_professional')} </b>
                        <br/><br/>
                        {t('home.perfect_for_you')+"!"}
                    </p>
                    <Button round color="white" style={{color:'#3a7bd5',fontWeight:500}}>
                        {t('home.select_plan')}
                    </Button>
                    </CardBody>
                </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                <Card pricing raised>
                    <CardBody pricing>
                    <h6 className={classes.cardCategory}>{t('home.essential')} </h6>
                    <div className={classes.icon}>
                        <Home className={classes.iconRose} />
                    </div>
                    <h3 className={`${classes.cardTitle} ${classes.marginTop30}`}>
                    {t('sale.dollar_sign')} 59,99
                    </h3>
                    <p className={classes.cardDescription}>
                        <b>{t('home.up_to_05_Professionals')} </b> 
                        <br/><br/>
                        {t('home.perfect_for_you_and_your_business')}
                    </p>
                    <Button round style={{background:'#3a7bd5',fontWeight:500}} >
                        {t('home.select_plan')}
                    </Button>
                    </CardBody>
                </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                <Card pricing plain>
                    <CardBody pricing plain>
                    <h6 className={classes.cardCategory}>{t('home.pro')} </h6>
                    <div className={classes.icon}>
                        <Business className={classes.iconWhite} />
                    </div>
                    <h3
                        className={`${classes.cardTitleWhite} ${classes.marginTop30}`}
                    >
                        {t('sale.dollar_sign')} 119,99
                    </h3>
                    <p className={classes.cardCategory}>
                        <b>{t('home.up_to_20_Professionals')} </b>
                        <br/><br/>
                        {t('home.perfect_for_those')}
                    </p>
                    <Button round color="white" style={{color:'#3a7bd5',fontWeight:500}}>
                            {t('home.select_plan')}
                    </Button>
                    </CardBody>
                </Card>
                </GridItem>
            </GridContainer>
            </div>
          </div>
          </section>

          <section>
              <div className="container mt-5 mb-5">
                  <div className="row align-items-center">
                      <div className="col-12 col-sm-6 col-md-6 text-center">
                          <img src={mobile} alt=""   className="img-fluid"/>
                      </div>
                      <div className="col-12 col-sm-6 col-md-6 mt-3">
                          <h3>
                              {t('home.download_our_app')+"!"}
                          </h3>
                          <p>
                           {t('home.whith_beakt_day')}
                           </p>
                           <p>
                            {"-"+t('home.consultation_alteration_cancellation')+";"} </p>
                           <p>
                           {"-"+t('home.secure_direct_payment_via_the_app_soon')+";"}</p>
                           <p>
                           {"-"+t('home.benefits_and_discounts_soon')+";"}</p>
                           <p>
                           {t('home.and_much_more')} </p>

                            <p>{t('home.coming_soon')} </p>

                          <img src={googlePlay} alt=""   height="40"/>
                          <img src={appleStore} alt=""   height="40"/>
                      </div>
                  </div>
              </div>
          </section>

          
          <footer className='landingFooter'>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-12 text-center">
                        <img width="180px" alt="logo" src={logo}/>
                    </div>
                    <div className="col-12 col-sm-4 col-md-4 tleft">
                        <Link to="/institutionalday/home" className="d-block text-light">{t('sidebar.home')} </Link>
                        <Link to="/institutionalday/register"  className="d-block text-light">{t('home.record')} </Link>
                        <Link to="/institutionalday/login"  className="d-block text-light">{t('login.login')} </Link>
                    </div>
                    <div className="col-12 col-sm-4 col-md-4" style={{fontSize:'12px'}}>
                        &copy; 2012-{1900 + new Date().getYear()}{" "}
                        <b><a
                            href="https://www.csjsistemas.com.br"
                            target="_blank"
                            style={{color:'#003157', fontWeight:'bold'}}
                        >
                        CSJ SISTEMAS,
                        </a></b> <i>{t('home.Driven_by_innovation')} </i>
                    </div>
                    <div className="col-12 col-sm-4 col-md-4 social text-right">
                        <a href="#">
                            <i className="fab fa-facebook-square"></i>
                        </a>
                        <a href="javascript:void(0)">
                            <i className="fab fa-instagram"></i>
                        </a>
                        <a href="javascript:void(0)">
                            <i className="fab fa-youtube"></i>
                        </a>
                        <a href="javascript:void(0)">
                            <i className="far fa-envelope"></i>
                        </a>
                    </div>
                </div>
            </div>
        </footer>

    </div>
  );
}